module.exports = __webpack_public_path__ + "static/media/social_linkedin_blue.59b82190.svg";